<template>
  <section class="wrapper">
    <div :class="containerClass">
      <section class="desc">
        <h2 class="title">
          Workera AI career pathway report
        </h2>
        <div class="description">
          Companies everywhere are building AI teams, but it’s still unclear
          what aspiring MLEs should focus on when applying for ML jobs. Our AI
          career pathways report walks you through the different AI career paths
          you can take, the tasks you’ll work on, and the skills companies are
          looking for in each role.
        </div>
        <div v-if="$mq !== 'desktop'" class="img-desc">
          <img
            v-lazy-load data-src="~/assets/img/landing-page/career-pathway/ai-career-pathways-copy.png"
          />
        </div>
        <a
          style="text-decoration: none"
          href="https://workera.ai/resource_downloads/ai_career_pathways/"
          target="blank"
          class="yellow-button-no-border"
        >
          <!--div class="yellow-button-1">Download the report</div-->
          Download the report
        </a>
      </section>
      <div v-if="$mq === 'desktop'" class="img-desc">
        <img
          v-lazy-load data-src="~/assets/img/landing-page/career-pathway/ai-career-pathways-copy.png"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    containerClass() {
      switch (this.$mq) {
        case "desktop":
          return "skills-boost column--duo--equivalent";
        case "tablet":
          return "skills-boost single";
        default:
          return "skills-boost single mobile";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  .skills-boost {
    padding: 4rem 1rem;

    .desc {
      .title {
        margin-bottom: 2rem;
      }

      .yellow-button-1 {
        margin-top: 2rem;
        padding: 1rem;
        width: 50%;
        font-weight: 700;
        font-size: 20px;
        line-height: 26.16px;
        letter-spacing: 0.03px;

        a {
          color: inherit;
          padding: 0;
        }
      }
      .yellow-button-no-border {
        margin-top: 2rem;
        padding: 1rem;
        width: 50%;
        font-weight: 700;
        font-size: 20px;
        line-height: 26.16px;
        letter-spacing: 0.03px;
        &:hover {
          background-color: $yellow-background-hover !important;
        }
      }
    }

    .img-desc {
      display: flex;
      img {
        max-width: 90%;
        margin: auto;
        margin-top: 1rem;
        max-height: 350px;
      }
    }
  }

  .skills-boost.column--duo--equivalent {
    padding: 4rem 1.5rem;
    .desc {
      .title {
        max-width: 80%;
        font-weight: 800;
        font-size: 36px;
        line-height: 36px;
        letter-spacing: -0.8px;
      }

      .description {
        max-width: 85%;
        font-weight: 600;
        font-size: 18px;
        line-height: 23.54px;
        letter-spacing: 0.03px;
      }
    }
  }

  .single {
    padding: 4rem 1.5rem;
    .desc {
      .title {
        font-weight: 800;
        font-size: 32px;
        line-height: 32px;
        letter-spacing: -0.8px;
      }

      .description {
        max-width: 85%;
        font-weight: 600;
        font-size: 18px;
        line-height: 23.54px;
        letter-spacing: 0.03px;
      }

      .yellow-button-no-border {
        margin: auto;
        margin-top: 2rem;
        padding: 1rem;
        width: 50%;
        font-weight: 600;
        font-size: 20px;
        line-height: 26.16px;
        letter-spacing: 0.03px;
        &:hover {
          font-weight: 700;
        }
      }
    }
  }

  .single {
    &.mobile {
      padding: 2rem 1.5rem;

      .desc {
        .yellow-button-no-border {
          width: 100%;
        }
      }
    }
  }
}
</style>
